var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSms = function SvgSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 10a7.52 7.52 0 0 1-7.5 7.5h-2.5l-4 4v-4H8a7.5 7.5 0 0 1 0-15h8a7.52 7.52 0 0 1 7.5 7.5",
    className: "sms_svg__smsicon"
  })));
};
export default SvgSms;